<p-dialog
		[(visible)]="visibleLocal"
		[draggable]="true"
		modal="true"
		(onHide)="fermerModal()"
		styleClass="modale-medium"
		[closable]="true">
	<alert [nom]="NOM_ALERTE_DETAIl_EVENEMENT_MODAL"></alert>

	<div class="detail-evenement-modal-container">
		<div class="container-gauche">
			<div class="information-evenement">
				<span class="label-information-evenement">{{ 'ACCUEIL.DETAIL_EVENEMENT.TYPE_EVENEMENT' | translate }}</span>
				<span class="valeur-information-evenement"><i [ngClass]="iconeSelonTypeEvenement()"></i> {{ evenement().typeEvenement.designation }}</span>
			</div>
			<div class="information-evenement">
				<span class="label-information-evenement">{{ 'ACCUEIL.DETAIL_EVENEMENT.DATE_DEMANDE' | translate }}</span>
				<span class="valeur-information-evenement">{{ formattageDateSansHeurePourAffichage(evenement().dateDemande) }}</span>
			</div>
			<div class="information-evenement">
				<span class="label-information-evenement">{{ 'ACCUEIL.DETAIL_EVENEMENT.DATE_EVENEMENT' | translate }}</span>
				<span class="valeur-information-evenement date-evenement">{{ formattageDateSansHeurePourAffichage(evenement().date) }}</span>
			</div>
			@if (estEvenementTeletravail()) {
				<div class="information-evenement">
					<span class="label-information-evenement">{{ 'ACCUEIL.DETAIL_EVENEMENT.STATUT' | translate }}</span>
					<div class="container-statut-duree statut" [ngClass]="determinerClasseStatut(evenement().statut.code)">
						{{ evenement().statut.designation }}
					</div>
				</div>
			}
			<div class="information-evenement">
				<span class="label-information-evenement">{{ 'ACCUEIL.DETAIL_EVENEMENT.DUREE' | translate }}</span>
				<span class="valeur-information-evenement">{{ evenement().duree.designation }}</span>
			</div>
			@if (afficherInformationsValidation()) {
				<div class="information-evenement">
					<span class="label-information-evenement">{{ messageValideLeOuRefuseLe() }}</span>
					<span class="valeur-information-evenement">{{ isNullOrUndefined(evenement().dateValidation) ? '' : formattageDateHeurePourAffichage(evenement().dateValidation) }}</span>
				</div>
			}
		</div>
		@if (!isBlank(evenement().commentaire.trim())) {
			<div class="container-droite">
				@if (!isBlank(evenement().commentaire.trim())) {
					<div class="information-evenement-commentaire">
						<span class="label-information-evenement">{{ 'ACCUEIL.DETAIL_EVENEMENT.COMMENTAIRE' | translate }}</span>
						<div class="container-commentaire">
							<span class="valeur-information-evenement">{{ evenement().commentaire }}</span>
						</div>
					</div>
				}
			</div>
		}
	</div>
	<p-footer>
		@if (estAfficherBoutonAnnulation()) {
			<span class="btn-annuler-evenement">
				<p-button
						[label]="'ACCUEIL.DETAIL_EVENEMENT.BTN_ANNULER_EVENEMENT' | translate"
						type="button"
						icon="pi pi-times-circle"
						[loading]="loadingAnnulation()"
						(click)="annulerEvenement()"/>
			</span>
		}
		<p-button
				[label]="'GLOBAL.BTN_FERMER' | translate"
				type="button"
				styleClass="p-button-link"
				(click)="fermerModal()"/>
	</p-footer>
</p-dialog>
